import { classes } from "../../nucleo/classes";

/**
 * O símbolo da marca: arco quase fechado mais o quadrado turquesa no canto superior direito.
 * É a mesma geometria do data-URI `--mark-dark` do protótipo v7, aqui em SVG inline para o
 * traço poder herdar `currentColor` — assim o símbolo acompanha o tema sem uma segunda
 * imagem, que é exatamente o que o protótipo precisava fazer com `--mark-light`.
 */
export function SimboloGeovendas({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 32 32"
      className={classes("marca__simbolo", className)}
      role="img"
      aria-label="GEOvendas"
      focusable="false"
    >
      <path
        d="M16 5 A11 11 0 1 0 27 16"
        fill="none"
        stroke="currentColor"
        strokeWidth="6"
      />
      <rect x="16" y="2" width="14" height="14" fill="var(--brand-turquesa)" />
    </svg>
  );
}

export interface PropsDaMarca {
  /** Nome da área do portal, à direita do logotipo. */
  area?: string;
  className?: string;
}

export function MarcaGeovendas({ area, className }: PropsDaMarca) {
  return (
    <div className={classes("marca", className)}>
      <span className="marca__identidade">
        <SimboloGeovendas />
        <span className="marca__nome">
          <b>GEO</b>
          <span>vendas</span>
        </span>
      </span>
      {area ? <span className="marca__area">{area}</span> : null}
    </div>
  );
}
